import type { ProductVariant } from "@graphql/generated/components";
import ClickAndCollect from "@lib/constants/contentful/clickAndCollect";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Button } from "@ui/components/forms/button/Button";
import { Circle } from "@ui/components/layout/center/Circle";
import { Flex } from "@ui/components/layout/flex/Flex";
import type { StoreData } from "../store-locator/controller";
import { useStore } from "@store/store";

type Props = {
    store?: StoreData;
    onClose?: () => void;
    selectedVariant?: ProductVariant;
};

export const AvailabilityComponent = ({ store, onClose, selectedVariant }: Props) => {
    const setStoreData = useStore((state) => state.setStoreData);

    const { getMultiple } = useMicrocopy();
    const selectedVariantChannelsId = selectedVariant.availability.channels.results;
    const handleSetStore = async () => {
        setStoreData(store);
        onClose();
    };

    const microcopies = (() => {
        return getMultiple("page", [
            ClickAndCollect.availableSoon,
            ClickAndCollect.available,
            ClickAndCollect.selectStore,
            ClickAndCollect.changeStore,
        ]);
    })();

    const foundStore = selectedVariantChannelsId.some((supplyChannels) => {
        return (
            supplyChannels.channel.id === store?.supplyChannel[0].id &&
            supplyChannels.availability.isOnStock
        );
    });

    const availabilityColor = foundStore ? "green.200" : "yellow.200";
    const availabilityText = foundStore
        ? microcopies[ClickAndCollect.available]
        : microcopies[ClickAndCollect.availableSoon];
    return (
        <Flex
            justifyContent={"space-between"}
            color="black"
            fontWeight="bold"
            flexDirection={["column", "column", "row"]}
            gap={4}
        >
            <Flex gap={2} fontSize={"mobileBodyTextSmall"} alignItems={"center"}>
                <Circle size={2} bg={availabilityColor} />
                {availabilityText}
            </Flex>
            <Button
                zIndex={10}
                h={10}
                w={["100%", "100%", "auto"]}
                fontSize={"mobileBodyTextNormal"}
                onClick={handleSetStore}
            >
                <span>{microcopies[ClickAndCollect.selectStore]}</span>
            </Button>
        </Flex>
    );
};
